export default __webpack_public_path__ + "static/media/bless.290b279c.png";